import type { SxProps, Theme } from '@mui/material';

export const pageSx: SxProps<Theme> = {
  minHeight: '100vh',
  boxSizing: 'border-box',
  bgcolor: 'grey.200',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4,
  px: 2,
  py: 6,
};

export const logoSx: SxProps<Theme> = {
  height: 36,
  width: 'auto',
};

export const cardSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 480,
  boxSizing: 'border-box',
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  '& h1': { fontSize: 24, fontWeight: 700, m: 0 },
};
